import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromHomeStore from './home-store.reducer';
import { EffectsModule } from '@ngrx/effects';
import { HomeStoreEffects } from './home-store.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromHomeStore.homeStoreFeatureKey, fromHomeStore.reducer),
    EffectsModule.forFeature([HomeStoreEffects])
  ]
})
export class HomeStoreModule { }
